import { useCallback, useEffect, useState } from 'react';
import type { BriefResultData, ExportStatus } from 'types/result';

export function useResultsState(initialResults?: BriefResultData[]) {
  const [resultsState, setResultsState] = useState<BriefResultData[]>(initialResults || []);

  useEffect(() => {
    if (initialResults) {
      setResultsState(initialResults);
    }
  }, [initialResults]);

  const handleStatusUpdate = useCallback((updatedStatus: ExportStatus, resultId: number) => {
    setResultsState((prev) =>
      prev.map((r) => (r.id === resultId ? { ...r, exportStatus: updatedStatus } : r))
    );
  }, []);

  return {
    resultsState,
    handleStatusUpdate,
  };
}
